import React from "react";
import { statusMeta, initials } from "@/lib/status";

/**
 * mode: "worker" | "detailed" | "compact" | "editor"
 * zoom: current map zoom so inner content scales with the card
 */
export default function BaldachinCard({ b, mode = "detailed", zoom = 1, selected, dimmed, onClick, editable }) {
  const meta = statusMeta(b.status);
  const isCompact = mode === "compact";
  const isEditor = mode === "editor";

  const renderW = (b.w || 92) * zoom;
  const digits = String(b.number).length;
  let numFs = renderW * (isCompact ? 0.36 : 0.46);
  if (digits >= 3) numFs *= 0.72;
  numFs = Math.max(9, numFs);
  const badgeFs = Math.max(7, renderW * 0.15);
  const smallFs = Math.max(7, renderW * 0.13);

  const showDetails = (mode === "worker" || mode === "detailed") && b.count > 0 && renderW >= 60;
  const showZone = isEditor && b.zone && renderW >= 58;

  return (
    <button
      type="button"
      onClick={editable ? undefined : onClick}
      data-testid={`baldachin-card-${b.number}`}
      data-status={b.status}
      className="group relative flex h-full w-full flex-col items-center justify-center overflow-hidden rounded-2xl border-2 text-center leading-none transition-transform duration-150 active:scale-95 touch-manipulation focus:outline-none"
      style={{
        background: meta.bg,
        borderColor: selected ? "#0EA5E9" : meta.border,
        color: meta.text,
        boxShadow: selected ? "0 0 0 3px rgba(14,165,233,0.45)" : "0 1px 2px rgba(0,0,0,0.05)",
        opacity: dimmed ? 0.25 : 1,
      }}
    >
      {b.count > 0 && renderW >= 44 && (
        <span
          className="absolute right-1 top-1 rounded-full px-1.5 py-0.5 font-bold leading-none"
          style={{ background: meta.badgeBg, color: meta.badgeText, fontSize: badgeFs }}
          data-testid={`baldachin-count-${b.number}`}
        >
          {b.count}x
        </span>
      )}

      <span className="font-heading font-black tracking-tighter" style={{ fontSize: numFs }}>
        {b.number}
      </span>

      {showZone && (
        <span className="mt-0.5 max-w-full truncate px-1 font-semibold opacity-70" style={{ fontSize: smallFs }}>
          {b.zone}
        </span>
      )}

      {showDetails && (
        <div className="mt-1 flex flex-col items-center gap-0.5">
          {b.last_action_time_label && (
            <span className="font-semibold opacity-90" style={{ fontSize: smallFs }}>{b.last_action_time_label}</span>
          )}
          {b.last_worker_name && (
            <span className="rounded-md px-1 py-0.5 font-bold" style={{ background: "rgba(255,255,255,0.25)", fontSize: smallFs }}>
              {initials(b.last_worker_name)}
            </span>
          )}
        </div>
      )}
    </button>
  );
}
